import { RefundStatus } from '@40seas/entities/refunds';
import { EnumColor } from '@40seas/frontend/common/providers';

export const refundStatusColorMapping = {
    [RefundStatus.Pending]: 'default',
    [RefundStatus.Initiated]: 'info',
    [RefundStatus.Succeeded]: 'success',
    [RefundStatus.Failed]: 'error',
} as { [key in RefundStatus]: EnumColor };
